// Convenient helper so callers can just pass the product object
export const getProductDisplayName = (p = {}) => {
  const manualTitle = String(p.title || "").trim();
  if (manualTitle) return manualTitle;

  const name = String(p.name || "").trim();
  if (name) return name;
  return "";
};
